import React from 'react';
import { twMerge } from 'tailwind-merge';

type BadgeProps = {
  badgeText?: string;
  className: string;
};

export const BetaBadgeClasses =
  'text-xs text-white bg-blue-1000 rounded-lg px-2 py-1';

const Badge = ({ badgeText = 'Beta', className }: BadgeProps) => {
  return (
    <span className={twMerge(BetaBadgeClasses, className)}>{badgeText}</span>
  );
};

export default Badge;
